// Auto-generated from old repo translations - do not edit by hand
const fr: Record<string, string> = {
  'logo.white': 'newlogo200.png',
  'logo.whiteLarge': 'newlogo400.png',
  'logo.green': 'creaticodeword_en_300.png',
  'logo.greenLarge': 'creaticodeword_en_600.png',
  'logo.logo': 'en-logo.png',
  'WhyBanner.mainTitle': 'Pourquoi CreatiCode?',
  'WhyBanner.creativeTitle': 'Compatible avec\nMIT Scratch',
  'WhyBanner.creativeContent':
    "Notre plate-forme est basée sur la version open source de MIT Scratch 3.0, avec de nombreuses nouvelles fonctionnalités qui vous rendent plus productif. Vous trouverez qu'il est très facile de démarrer.",
  'WhyBanner.contactTitle': 'Langage\n3D simplifié',
  'WhyBanner.contactContent':
    "Nous avons conçu un système de blocs faciles à comprendre pour la programmation 3D, afin que vous n'ayez pas à apprendre un autre langage ou interface de codage complexe.",
  'WhyBanner.focusTitle': 'Cours à votre rythme\n',
  'WhyBanner.focusContent':
    "Nous proposons des micro-leçons échafaudées avec des projets pratiques ciblés, afin que vous preniez le contrôle de votre parcours et de votre rythme d'apprentissage en fonction de votre temps et de votre préparation.",
  'WhyBanner2.mainTitle': 'Pourquoi la programmation 3D?',
  'WhyBanner2.creativeTitle': 'Une Expérience\nSuper Fun',
  'WhyBanner2.creativeContent':
    "Créer des projets 3D, c'est comme jouer à des jeux, avec des mondes virtuels infiniment grands, des objets/personnages réalistes, des caméras en mouvement libre et des interactions utilisateur engageantes.",
  'WhyBanner2.contactTitle': 'Entraînement cérébral\ncomplet',
  'WhyBanner2.contactContent':
    'Travailler sur des projets 3D développe à la fois le cerveau gauche (science, mathématiques et raisonnement logique) et le cerveau droit (design créatif et raisonnement spatial).',
  'WhyBanner2.focusTitle': 'Future\nTechnologies',
  'WhyBanner2.focus Content':
    "La programmation 3D jette les bases de nombreuses nouvelles technologies, telles que le métaverse (VR/AR), la conception assistée par ordinateur (CAO) et l'impression 3D.",
  'WhyBanner3.mainTitle': "Pourquoi l'IA?",
  'WhyBanner3.creativeTitle': "Des opportunités\nd'apprentissage infinies",
  'WhyBanner3.creativeContent':
    "L'IA ouvre un monde d'opportunités d'apprentissage. Des notions de base aux techniques avancées, les élèves peuvent développer leurs compétences dans un domaine en évolution rapide.",
  'WhyBanner3.contactTitle': 'Former les\ninnovateurs de demain',
  'WhyBanner3.contactContent':
    "L'apprentissage de l'IA donne aux élèves les outils pour innover, résoudre des problèmes du monde réel et faire progresser la technologie.",
  'WhyBanner3.focusTitle': 'Comprendre les enjeux\néthiques',
  'WhyBanner3.focusContent':
    "Apprendre l'IA aide les élèves à comprendre des questions éthiques comme les biais et la vie privée. Cela dissipe aussi les craintes d'une IA qui remplacerait les humains, en clarifiant ses véritables capacités.",
  'VideoBannerTop.sectionTitle': 'CreatiCode en action',
  'VideoBannerTop.creativeTitle': 'Aire de jeu\nScratch 2D améliorée',
  'VideoBannerTop.contactTitle': '3D Scratch\nTerrain de jeu',
  'VideoBannerTop.focusTitle': 'Programme\nauto-rythmé',
  'VideoBannerTop.creative.title': 'Aire de jeu\nScratch 2D améliorée',
  'VideoBannerTop.creative.mediaLink': 'https://videos.creaticode.com/enhanced-2d-scratch-playground.mp4',
  'VideoBannerTop.contact.title': '3D Scratch\nTerrain de jeu',
  'VideoBannerTop.contact.mediaLink': 'https://videos.creaticode.com/3d-scratch-playground.mp4',
  'VideoBannerTop.focus.title': 'Programme\nauto-rythmé',
  'VideoBannerTop.focus.mediaLink': 'https://videos.creaticode.com/self-paced-curriculum.mp4',
  'VideoBannerTop.creativeCN.title': 'Ecrire des programmes 3D\navec des blocs Scratch',
  'VideoBannerTop.creativeCN.mediaLink': '//player.bilibili.com/player.html?aid=605135896&bvid=BV1m84y1y7kx&cid=892225349&page=1',
  'TopBanner.creaticode': 'CreatiCode',
  'TopBanner.Header': 'CreatiCode - 3D Pour Tout Le Monde',
  'TopBanner.BriefIntroduction.0': 'Outils IA',
  'TopBanner.BriefIntroduction.1': 'Code et design',
  'TopBanner.BriefIntroduction.2': 'Projets IA + 3D',
  'TopBanner.SignUpButton': 'INSCRIPTION GRATUITE',
  'TopBanner.menu': 'MENU',
  'TopBanner.NavBarButtons.games': 'JEUX',
  'TopBanner.NavBarButtons.courses': 'COURS',
  'TopBanner.NavBarButtons.dashboard': 'TABLEAU DE BORD',
  'TopBanner.NavBarButtons.myStuff': 'MES AFFAIRES',
  'TopBanner.NavBarButtons.leaderBoard': 'CLASSEMENT',
  'TopBanner.NavBarButtons.forum': 'FORUM',
  'TopBanner.NavBarButtons.about': 'À PROPOS',
  'TopBanner.NavBarButtons.contact': 'CONTACT',
  'TopBanner.NavBarButtons.create': 'CRÉER',
  'TopBanner.NavBarButtons.joinNow': 'INSCRIPTION GRATUITE',
  'TopBanner.NavBarButtons.logout': 'SE DÉCONNECTER',
  'TopBanner.NavBarButtons.signIn': 'CONNEXION',
  'TopBanner.NavBarButtons.explore': 'EXPLORER',
  'TopBanner.NavBarButtons.olympic': 'OLYMPIQUE',
  'TopBanner.NavBarButtons.learn': 'APPRENDRE',
  'TopBanner.NavBarButtons.hourOfCode': 'TUTORIELS',
  'TopBanner.guideLine': 'Conduire: W/S/A/D\nArrêter/Retourner: SPACE',
  'TopBanner.signIn': 'Connexion',
  'TopBanner.join': 'Rejoindre',
  'TopBanner.myStuff': 'Mes affaires',
  'TopBanner.slogan': 'CreatiCode : codage 2D + 3D avec blocs Scratch',
  'TopBanner.subtitle': "Coder avec l'IA et la 3D devient simple, créatif et amusant.",
  'TopBanner.whatBody':
    "CreatiCode s'appuie sur Scratch 3.0 avec des outils d'IA et de 3D pensés pour les élèves. Ils peuvent générer des images, obtenir de l'aide pour coder et utiliser des blocs d'IA pour ajouter vision, voix, chat et autres fonctions intelligentes à leurs projets.\n\nAvec des leçons guidées et des espaces créatifs, ils passent d'une idée à un projet alimenté par l'IA sans apprendre un langage complexe.",
  'Footer.Title.highlight': 'points forts',
  'Footer.Title.contact': 'Contactez-nous',
  'Footer.Title.community': 'Communauté',
  'Footer.Title.connect': 'Rester connecté',
  'Footer.Title.linkWithSocial': 'Lien avec Social',
  'Footer.Highlight.about-us': 'À propos de nous',
  'Footer.Highlight.contact': 'Contact',
  'Footer.Highlight.create': 'Créer',
  'Footer.Highlight.explore': 'Explorer',
  'Footer.Highlight.founder-story': 'Histoire du fondateur',
  'Footer.Highlight.advisor-team': 'Équipe de conseillers',
  'Footer.Highlight.join-us': 'Rejoignez-nous',
  'Footer.Highlight.forum': 'Forum',
  'Footer.Highlight.privacy-policy': 'Politique de confidentialité',
  'Footer.Highlight.tutorials': 'Tutoriels',
  'Footer.CopyRight': 'Tous les droits sont réservés',
  'Footer.Title.mission': 'Mission',
  'Footer.mission': 'Permettre à chaque personne de créer, de résoudre des problèmes et de donner vie à ses idées avec l’IA.',
  'DashBoardHeader.NavBarButtons.dashboard': 'PANNEAUX',
  'DashBoardHeader.NavBarButtons.games': 'JEUX',
  'DashBoardHeader.NavBarButtons.courses': 'COURS',
  'DashBoardHeader.NavBarButtons.leaderBoard': 'CLASSEMENT',
  'DashBoardHeader.NavBarButtons.forum': 'FORUM',
  'DashBoardHeader.NavBarButtons.about': 'À PROPOS',
  'DashBoardHeader.NavBarButtons.contact': 'CONTACT',
  'DashBoardHeader.NavBarButtons.create': 'CRÉER',
  'DashBoardHeader.NavBarButtons.joinNow': 'INSCRIPTION GRATUITE',
  'DashBoardHeader.NavBarButtons.logout': 'SE DÉCONNECTER',
  'DashBoardHeader.NavBarButtons.admin': 'ADMINISTRER',
  'DashBoardHeader.NavBarButtons.signIn': 'CONNEXION',
  'DashBoardHeader.NavBarButtons.teacher': 'PROF',
  'DashBoardHeader.NavBarButtons.school': "L'ÉCOLE",
  'DashBoardHeader.NavBarButtons.migration': 'MIGRATION',
  'DashBoardHeader.NavBarButtons.explore': 'EXPLORER',
  'DashBoardHeader.NavBarButtons.olympic': 'OLYMPIQUE',
  'DashBoardHeader.NavBarButtons.learn': 'APPRENDRE',
  'DashBoardHeader.NavBarButtons.hourOfCode': 'TUTORIELS',
  'DashBoardHeader.NavBarButtons.metrics': 'MÉTRIQUE',
  'DashBoardHeader.NavBarButtons.setting': 'PARAMÈTRE',
  'DashBoardHeader.NavBarButtons.discounts': 'RABAIS',
  'DashBoardHeader.NavBarButtons.support': 'SUPPORT',
  'UpperFooter.title': "Commencez à apprendre aujourd'hui",
  'UpperFooter.subTitle': 'et préparez-vous au monde des IA de demain',
  'UpperFooter.joinButton': 'Essayez-le maintenant',
  'ExampleProjects.title': 'Exemples de projets',
  'ExampleProjects.slides.rover.title': 'Mars Rover',
  'ExampleProjects.slides.rover.content': 'Un rover qui peut se déployer, se déplacer et tourner à la surface de Mars.',
  'ExampleProjects.slides.rover.image': 'marsdemo1_600.gif',
  'ExampleProjects.slides.solar.title': 'Solar System',
  'ExampleProjects.slides.solar.content': 'Simulation of the rotation and spin of planets in the solar system.',
  'ExampleProjects.slides.solar.image': 'solar.gif',
  'ExampleProjects.slides.d3maze.title': 'Jeu de labyrinthe',
  'ExampleProjects.slides.d3maze.content': "Conduire une voiture hors d'un labyrinthe de murs.",
  'ExampleProjects.slides.d3maze.image': '3dmazedemo.gif',
  'ExampleProjects.slides.d3walkway.title': 'Passerelle',
  'ExampleProjects.slides.d3walkway.content': 'Une passerelle flottante composée de 3 briques volantes.',
  'ExampleProjects.slides.d3walkway.image': '3dwalkway.gif',
  'ExampleProjects.slides.magellan.title': "L'expédition de Magellan en 3D",
  'ExampleProjects.slides.magellan.content': 'Suivez la flotte de Magellan pour faire le tour du monde.',
  'ExampleProjects.slides.magellan.image': 'm2.gif',
  'ExampleProjects.slides.boymirror.title': 'Personnages animés',
  'ExampleProjects.slides.boymirror.content': 'Un garçon jouant sur un immense miroir.',
  'ExampleProjects.slides.boymirror.image': 'boy3.gif',
  'ExampleProjects.slides.d3bus.title': 'Autobus',
  'ExampleProjects.slides.d3bus.content': 'Un bus complet avec des roues, des fenêtres, des portes et des lumières.',
  'ExampleProjects.slides.d3bus.image': 'busdemo.gif',
  'ExampleProjects.slides.ai.title': "Joueurs de jeux d'IA",
  'ExampleProjects.slides.ai.content':
    'Apprenez à jouer à un jeu manuellement, puis suivez des didacticiels pour créer un bot de jeu qui joue automatiquement au jeu.',
  'ExampleProjects.slides.ai.image': 'MonkeyGame.gif',
  'ExampleProjects.slides.drawing.title': 'Géométrie pour le dessin',
  'ExampleProjects.slides.drawing.content':
    'Concevez et dessinez des images intéressantes avec des programmes pour acquérir des connaissances en programmation et en géométrie en même temps',
  'ExampleProjects.slides.drawing.image': 'château1.gif',
  'ExampleProjects.slides.algorithms.title': 'Algorithmes classiques',
  'ExampleProjects.slides.algorithms.content':
    'Maîtrisez les algorithmes classiques (par exemple le tri et la recherche) grâce à des activités débranchées et des simulations animées.',
  'ExampleProjects.slides.algorithms.image': 'FootBallGame.gif',
  'ExampleProjects.slides.simulate.title': 'Simuler une application réelle',
  'ExampleProjects.slides.simulate.content':
    "Construisez des prototypes de diverses solutions d'IA du monde réel pour comprendre les applications de base de l'IA.",
  'ExampleProjects.slides.simulate.image': 'PandaGame.gif',
  'ExampleProjects.slides.introducing.title': "Introduction aux algorithmes d'IA",
  'ExampleProjects.slides.introducing.content':
    "Mettre en œuvre des projets d'IA simplifiés pour apprendre des modèles et des algorithmes d'IA.",
  'ExampleProjects.slides.introducing.image': 'NumberDrawingGame.gif',
  changeLanguage: 'Changer de langue',
};

export default fr;
